import React, { Component } from 'react'
import { connect } from "react-redux";
import { Helmet } from 'react-helmet-async';
import { Button } from 'reactstrap';
import MUIDataTable from "mui-datatables";
import IconButton from '@mui/material/IconButton';
import Selectsearch from "react-select";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import moment from 'moment';
// intl messages
import IntlMessages from 'Util/IntlMessages';
// page title bar
import PageTitleBar from 'Components/PageTitleBar/PageTitleBar';
// app config
import AppConfig from 'Constants/AppConfig';
import ConfirmationDialog from "Routes/common/ConfirmationDialog";

import {
   FormGroup,
   Label,
} from 'reactstrap';

import {
   allCaptoReport,
   deleteCaptoReport,
   allStudents,
   fetchCaptoReport,
} from 'Actions';

// rct card box
import RctCollapsibleCard from 'Components/RctCollapsibleCard/RctCollapsibleCard';

import AddItem from './component/addform';
import ViewItem from './component/viewform';
import EditForm from './component/editform';

import EditOutlinedIcon from '@mui/icons-material/EditOutlined';
import DeleteOutlineOutlinedIcon from '@mui/icons-material/DeleteOutlineOutlined';

class captoreport extends Component {

   constructor(props) {

      super(props);
      this.confirmationDialog = React.createRef();
      this.state = {
         viewdiv: true,
         adddiv: false,
         editdiv: false,
         editdiv2: false,
         seldate: '',
         student: '',
         eid: '',
         selectedFile: '',
      };

      this.onBackSection = this.onBackSection.bind(this);
      this.deleteForm = this.deleteForm.bind(this);
   }

   UNSAFE_componentWillMount() {
      this.props.allCaptoReport();
      this.props.allStudents();
   }

   selstudent = (evt) => {
      var stdid = evt.value;
      this.setState({ student: stdid });
   }

   selectdate = (date) => {
      const seldate = moment(new Date(date)).format('yyyy-MM-DD');
      this.setState({ seldate: date });

   }

   onAddSession() {
      this.setState({
         viewdiv: false,
         editdiv: false,
         adddiv: true,
      });
   }

   onBackSection() {
      this.setState({
         adddiv: false,
         editdiv: false,
         viewdiv: true,
         editdiv2:false,
      });
   }


   editAssessment(assmval) {

      var id = assmval.tsr_userID;
      var date = assmval.tsr_date;

      this.props.fetchCaptoReport(id, date).then((data) => {

         this.setState({
            viewdiv: false,
            adddiv: false,
            editdiv: true,
            editdiv2: false, 
         });

      });
   }

   editAssessment2(assmval) {

      var id = assmval.tsr_userID;
      var date = assmval.tsr_date;
      this.setState({ student: id });
      this.props.fetchCaptoReport(id, date).then((data) => {

         this.setState({
            viewdiv: false,
            adddiv: false,
            editdiv: false,
            editdiv2: true,
         });

      });
   }


   deleteForm(assmval) {
      this.id = assmval.tsr_userID;
      this.date = assmval.tsr_date;
      this.confirmationDialog.current.openDialog();
   }

   deleteDataPermanent(popupResponse) {

      if (popupResponse) {
         this.props.deleteCaptoReport(this.id, this.date);
         this.data = ""
      }
   }



   render() {
      const { match, captoreportlist, studentlists, loading } = this.props;

      const allstudent = studentlists.map((stdval) => {
         return {
            label: stdval.student,
            value: stdval.uudID
         }
      });

      const options = {
         filterType: 'dropdown',
         rowsPerPage: 50,
         rowsPerPageOptions: [50, 100, 150],
         selectableRowsHideCheckboxes: true,
      };

      const columns = [
         { name: "no", label: "NO" },
         { name: "name", label: "NAME" },
         { name: "cdate", label: "DATE" },
         { name: "action", label: "REPORT" },
         { name: "action1", label: "ACTION1" },

      ];
         const tabledata = Array.isArray(captoreportlist) ? captoreportlist.map((assmntval, idx) => {
         const flbtn = <a onClick={() => this.editAssessment(assmntval)}><span className="badge badge-info" >View</span></a>;
         const editBtn = (
            <IconButton className="text-info" aria-label="edit" onClick={() => this.editAssessment2(assmntval)}><EditOutlinedIcon/></IconButton>
         );
         const deleteBtn = (
            <IconButton
               className="text-danger"
               aria-label="Remove"
               onClick={() => this.deleteForm(assmntval)}
            >
               <DeleteOutlineOutlinedIcon/>
            </IconButton>
         );
         return {
            no: idx + 1,
            name: assmntval.student,
            cdate: assmntval.cdate,
            action: flbtn,
            action1: (
               <div>
                  {editBtn} {deleteBtn}
               </div>
            ),

         }
      }) : [];

      return (
         <div className="saas-dashboard">
            <Helmet>
               <title>CAPTO PUTTING EVALUATION | {AppConfig.appTitle}</title>
               <meta name="description" content="Golf" />
            </Helmet>
            <PageTitleBar title={<IntlMessages id="sidebar.captoreport" />} match={match} />

            {this.state.viewdiv &&
               <div className="col-sm-12 col-md-12">
                  <RctCollapsibleCard heading="List" fullBlock>
                     <MUIDataTable
                        title={<div><Button onClick={() => this.onAddSession()} className="btn btn-outline-info"><i className="zmdi zmdi-plus-circle-o"></i>  Add Report</Button></div>}
                        data={tabledata}
                        columns={columns}
                        options={options}
                     />
                  </RctCollapsibleCard>
               </div>
            }
            {this.state.adddiv &&
               <AddItem onClick={this.onBackSection} data={this.state}/>
            }

            {this.state.editdiv &&
               <ViewItem onClick={this.onBackSection}/>
            }

            {this.state.editdiv2 &&
               <EditForm onClick={this.onBackSection} data={this.state}/>
            }

            <ConfirmationDialog
               ref={this.confirmationDialog}
               onConfirm={(res) => this.deleteDataPermanent(res)}
               data={'capto putting report'}
            />

         </div>
      )
   }
}

const mapStateToProps = ({ captoreport, mostlyused }) => {
   const { captoreportlist, loading } = captoreport;
   const { studentlists } = mostlyused;
   return { captoreportlist, studentlists, loading };
}

export default connect(mapStateToProps, {
   allCaptoReport,
   allStudents,
   deleteCaptoReport,
   fetchCaptoReport
})(captoreport); 